import { motion } from "framer-motion";
import { IMG, ATMO } from "@/config/site";

export const PROJECTS = [
  {
    img: IMG.terrasse,
    title: "Moderner Stadtgarten",
    place: "Bremen",
    tag: "Gestaltung · Wegebau",
    text: "Klare Beetkanten, Rasenweg und Rankelemente geben der Fläche Struktur und Tiefe.",
  },
  {
    img: IMG.formal,
    title: "Terrasse am Rasen",
    place: "Bremen",
    tag: "Terrasse · Rasen",
    text: "Großformatige Platten treffen auf eine präzise gezogene Rasenkante.",
  },
  {
    img: IMG.umbau,
    title: "Rasen mit Hausbaum",
    place: "Bremen-Nord",
    tag: "Rasen · Bepflanzung",
    text: "Neu angelegte Fläche mit verankertem Hausbaum und ruhigen Randbereichen.",
  },
  {
    img: IMG.rasen,
    title: "Garten im Wandel",
    place: "Umgebung Bremen",
    tag: "Umgestaltung · Naturstein",
    text: "Modellierte Fläche, neues Steinbeet und vorbereitete Pflanzbereiche in der Bauphase.",
  },
  {
    img: ATMO.terrassiert,
    title: "Terrassierte Hangfläche",
    place: "Referenzbild",
    tag: "Mauern · Höhen",
    text: "Höhenunterschiede werden zu nutzbaren Ebenen – ein Gestaltungsprinzip, das wir gerne anwenden.",
  },
];

const Card = ({ p, className = "", ratio = "aspect-[4/5]", index }) => (
  <motion.article
    data-testid={`project-card-${index}`}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
    className={`group relative ${className}`}
  >
    <div className={`overflow-hidden soft-mask ${ratio}`}>
      <img
        src={p.img}
        alt={`${p.title}, ${p.place} – Gartenprojekt von Hanse Garten Bremen`}
        className="h-full w-full object-cover transition-transform duration-[1.4s] ease-[cubic-bezier(.22,1,.36,1)] group-hover:scale-[1.07]"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#17251C]/80 via-transparent to-transparent opacity-0 transition-opacity duration-700 group-hover:opacity-100 soft-mask" />
      <div className="absolute inset-x-0 bottom-0 translate-y-4 p-6 opacity-0 transition-all duration-700 group-hover:translate-y-0 group-hover:opacity-100 md:p-8">
        <p className="display-xl text-xl text-[#F3EDE2] md:text-2xl">{p.title}</p>
        <p className="mt-1.5 text-[0.62rem] uppercase tracking-[0.28em] text-[#DCCDB4]">{p.place}</p>
      </div>
    </div>
    <div className="mt-4 flex items-baseline justify-between gap-4">
      <p className="display-xl text-base text-[#17251C] md:text-lg">{p.title}</p>
      <p className="text-[0.6rem] uppercase tracking-[0.24em] text-[#93A387]">{p.tag}</p>
    </div>
  </motion.article>
);

export const ProjectsEditorial = () => (
  <div data-testid="projects-editorial">
    {/* Desktop: asymmetrisches Editorial-Layout */}
    <div className="hidden md:block">
      <div className="grid grid-cols-12 gap-x-6 gap-y-16">
        <Card p={PROJECTS[0]} index={0} className="col-span-7" ratio="aspect-[4/3]" />
        <div className="col-span-5 flex flex-col justify-end pb-6">
          <p className="eyebrow">Arbeitsweise</p>
          <p className="mt-4 text-base leading-relaxed text-[#6E7A69]">
            Jedes Projekt beginnt mit der Fläche selbst: Licht, Boden, Sichtachsen, Wege. Erst danach entstehen
            Materialien, Formen und Bepflanzung – und ein Garten, der zu seinem Ort gehört.
          </p>
        </div>

        <Card p={PROJECTS[1]} index={1} className="col-span-4 col-start-2" ratio="aspect-[3/4]" />
        <Card p={PROJECTS[2]} index={2} className="col-span-6 col-start-7 mt-20" ratio="aspect-[16/11]" />

        <Card p={PROJECTS[3]} index={3} className="col-span-7" ratio="aspect-[16/10]" />
        <Card p={PROJECTS[4]} index={4} className="col-span-4 col-start-9 -mt-10" ratio="aspect-[3/4]" />
      </div>
    </div>

    {/* Mobile: Swipe-Galerie */}
    <div className="-mx-5 flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-4 no-scrollbar md:hidden">
      {PROJECTS.map((p, i) => (
        <div key={p.title} className="w-[78vw] shrink-0 snap-center">
          <Card p={p} index={i} ratio="aspect-[4/5]" />
        </div>
      ))}
    </div>
  </div>
);
